module.exports = __webpack_public_path__ + "static/media/bankCardsPlusKlarna.01c97fde.svg";